export default "__VITE_ASSET__iN57PO4b__"